// from general.js
/* global readCookie */
// from globalJavascriptVariables.tag
/* global csrfTokenCookieName */


// This depends on the user having already made at least one request to a non-cacheable, "secure." subdomain page,
// otherwise the cookie won't be present.
export const getCsrfToken = function () {
    return readCookie(csrfTokenCookieName);
};
